"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/common/http");
var resource_service_1 = require("../../shared/resource.service");
var driver_metadata_serializer_1 = require("./driver-metadata.serializer");
var AllDriversMetadataService = /** @class */ (function (_super) {
    __extends(AllDriversMetadataService, _super);
    function AllDriversMetadataService(http) {
        return _super.call(this, http, 'alldriversmapsmetadata/', new driver_metadata_serializer_1.DriverMetadataSerializer()) || this;
    }
    return AllDriversMetadataService;
}(resource_service_1.ResourceService));
exports.AllDriversMetadataService = AllDriversMetadataService;
